import { render } from "./HomeWarning.vue?vue&type=template&id=483f7c96&scoped=true"
import script from "./HomeWarning.vue?vue&type=script&lang=js"
export * from "./HomeWarning.vue?vue&type=script&lang=js"

import "./HomeWarning.vue?vue&type=style&index=0&id=483f7c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483f7c96"]])

export default __exports__